

import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const DataExportRetentionSection = () => {
  return (
    <div>
      <Paragraph>
        Customer may request an export of Customer Data upon termination of this
        Agreement or cancellation of the TrackBiz subscription.
      </Paragraph>

      <Paragraph>
        <Text strong>Data Export Rights</Text>
      </Paragraph>

      <ul>
        <li>Customer may request a copy of available business data.</li>
        <li>Data export requests must be submitted within thirty (30) days of termination.</li>
        <li>Exports will be provided in a commercially reasonable format determined by Provider.</li>
      </ul>

      <Alert
        message="30-Day Data Retrieval Window"
        description="Customer must request any desired data exports within thirty (30) days after termination or cancellation of the subscription."
        type="info"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Following the expiration of the thirty (30) day retrieval period, Provider
        may permanently delete Customer Data from production systems, backup
        systems, and related storage environments in accordance with Provider's
        data retention practices.
      </Paragraph>

      <Alert
        message="Permanent Deletion"
        description="Once Customer Data has been permanently deleted, Provider may be unable to recover or restore such data."
        type="warning"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Customer is solely responsible for maintaining copies of exported reports,
        records, customer information, inventory information, appointment data,
        and other business records necessary for Customer's ongoing operations,
        accounting, tax compliance, or legal obligations.
      </Paragraph>

      <Paragraph>
        Provider is not responsible for any loss of data resulting from Customer's
        failure to request a timely export or maintain copies of exported records.
      </Paragraph>
    </div>
  );
};

export default DataExportRetentionSection;